
export const getDefaultState = () => {
  return {
    listFeatureFlags: [],
  };
};
export const state = getDefaultState();
